import { Seo } from "../components/Seo";
import { Hero } from "../components/Hero";
import { Marquee } from "../components/Marquee";
import { TrustStrip } from "../components/TrustStrip";
import { Services } from "../components/Services";
import { Guarantee } from "../components/Guarantee";
import { FAQ } from "../components/FAQ";
import { ContactForm } from "../components/ContactForm";
import { FrameFeature, DmeHighlight, ServicesDirectory, ReviewsPlaceholder, HomeWorkGallery, HomeCta } from "../components/HomeExtras";
import { SITE_URL, BIZ } from "../data/site";

const websiteSchema = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  name: BIZ.name,
  url: SITE_URL,
};

export default function Home() {
  return (
    <div data-testid="home-page">
      <Seo
        title="Westway Collision Center | Auto Body Shop Carrollton, TX"
        description="Certified collision repair in Carrollton, TX for luxury & exotic vehicles. I-CAR Gold Class, frame machine, lifetime warranty. Free estimates: (214) 888-2886."
        path="/"
        schemas={[websiteSchema]}
      />
      <Hero />
      <Marquee />
      <TrustStrip />
      <FrameFeature />
      <Services />
      <ServicesDirectory />
      <Guarantee />
      <DmeHighlight />
      <HomeWorkGallery />
      <ReviewsPlaceholder />
      <FAQ />
      <ContactForm />
      <HomeCta />
    </div>
  );
}
